import React from "react";
import TextAreaInput from "./TextAreaInput";
import TextInput from "./TextInput";

function BillingDetails(props) {
  const { values, errors, dirty, handleOnChange, t} = props;
  const {
    billingFirstName,
    billingLastName,
    billingCountry,
    billingCity,
    billingFullAddress,
  } = values;
  return (
    <div className="row mt-4">
      <div className="col-sm-12">
        <h3>
          <img src="./images/billing-icon.svg" alt="User Icon" className="billing-icon" />
          {t("ENTER_YOUR_BILLING_ADDRESS_DETAILS")}
        </h3>
      </div>
      <div className="col-sm-6 mb-3">
        <div className="form-group">
          <TextInput
            id="billingFirstName"
            name="billingFirstName"
            label={t("FIRST_NAME")}
            placeholder=""
            onChange={handleOnChange}
            value={billingFirstName}
            required={true}
            validation={{ errors, dirty }}
            maxLength={100}
            t={t}
          />
        </div>
      </div>
      <div className="col-sm-6 mb-3">
        <div className="form-group">
          <TextInput
            id="billingLastName"
            name="billingLastName"
            label={t("LAST_NAME")}
            placeholder=""
            onChange={handleOnChange}
            value={billingLastName}
            required={true}
            validation={{ errors, dirty }}
            maxLength={100}
            t={t}
          />
        </div>
      </div>
      <div className="col-sm-6 mb-3">
        <div className="form-group">
         <TextInput
            className="form-control"
            id="billingCountry"
            name="billingCountry"
            label={t("COUNTRY")}
            onChange={handleOnChange}
            value={billingCountry}
            required={true}
            validation={{ errors, dirty }}
            maxLength={100}
            t={t}
          />
        </div>
      </div>
      <div className="col-sm-6 mb-3">
        <div className="form-group">
        <TextInput
            className="form-control"
            id="billingCity"
            name="billingCity"
            label={t("CITY")}
            onChange={handleOnChange}
            value={billingCity}
            required={true}
            validation={{ errors, dirty }}
            maxLength={100}
            t={t}
          />
        </div>
      </div>
      <div className="col-sm-12 mb-3">
        <TextAreaInput
          id="billingFullAddress"
          name="billingFullAddress"
          label={t("FULL_ADDRESS")}
          placeholder=""
          onChange={handleOnChange}
          value={billingFullAddress}       
          rows={4}
          maxLength={200}
          t={t}
        />
      </div>
    </div>
  );
}

export default BillingDetails;
